<template>
    <div class="card">
        <div class="card-header" id="headingThree">
            <h5 class="mb-0">
                <button
                    v-b-toggle="'collapseMrFilters' + queryCategory"
                    class="btn btn-link"
                    v-on:click="addInitialClause"
                    :id="'toggle-mr-query-button-' + queryCategory"
                >
                    <arrow-right-drop-circle-outline :size="17" />
                    <span>
                        {{ name }}
                        <span v-show="clauseCount > 0">({{ clauseCount }})</span>
                    </span>
                </button>
            </h5>
        </div>
        <b-collapse
            :id="'collapseMrFilters' + queryCategory"
            :accordion="'collapseMrFilters' + queryCategory + '-accordion'"
            role="tabpanel"
        >
            <div class="card-body" id="mr-filter-container">
                <div class="d-flex flex-column subQueryItemContainer">
                    <div ref="container"></div>
                    <span @click="onClick" class="add-or-clause-button blue-button">
                        <plus-circle :size="17" />
                        {{ this.$i18n.ADD_OR_BLOCK }}
                    </span>
                </div>
            </div>
        </b-collapse>
    </div>
</template>

<script>
import binarySubQueryItem from "./subquery-binary-item.vue";
import userEnabledDateSubquery from "./user-enabled-date.vue";
import OrClause from "./or-clause";
import Vue from "vue";
import { mapState } from "vuex";
import { BCollapse } from "bootstrap-vue";
import ArrowRightDropCircleOutline from "vue-material-design-icons/ArrowRightDropCircleOutline.vue";
import PlusCircle from "vue-material-design-icons/PlusCircle.vue";

export default {
    props: {
        queryCategory: String,
        name: String,
        module: String
    },
    data() {
        return {
            orClauses: [],
            clauseCount: 0,
        };
    },
    computed: {
        ...mapState({
            advancedQueryCriteria: (state) => state.advancedQueryCriteria,
        }),
    },
    components: {
        OrClause,
        binarySubQueryItem: binarySubQueryItem,
        userEnabledDateSubquery: userEnabledDateSubquery,
        BCollapse,
        ArrowRightDropCircleOutline,
        PlusCircle,
    },
    methods: {
        addInitialClause() {
            if (this.orClauses.length === 0) {
                this.onClick();
                this.orClauses[0].addInitialClause();
            }
        },
        reboot() {
            for (let or of this.orClauses) {
                for (let and of or.andClauses) {
                    and.$emit("deleteMe");
                }

                or.$emit("deleteMe");
            }
            this.orClauses = [];
            this.clauseCount = 0;
            this.updateTree();
        },
        onClick() {
            var ComponentClass = Vue.extend(OrClause);
            var instance = new ComponentClass({
                store: this.$store,
                propsData: { module: this.module },
            });
            instance.$mount();
            instance.$parent = this;
            instance.$on("deleteMe", function () {
                this.$emit("updateTree", this.id);
                instance.$destroy(true);
                instance.$el.remove();
            });
            instance.$on("updateTree", function (id) {
                if (id) {
                    this.$parent.orClauses = this.$parent.orClauses.filter((o) => o.id !== id);
                }
                this.$parent.updateTree();
            });
            this.$refs.container.appendChild(instance.$el);
            this.orClauses.push(instance);
        },
        updateTree() {
            let result = [];
            for (let or of this.orClauses) {
                if (or.andClauses.length > 0 && !or._isDestroyed) {
                    let orClauseResult = [];
                    for (let and of or._data.andClauses) {
                        if (!and._isDestroyed)
                            orClauseResult.push({
                                field: and._data.field,
                                operator: and._data.operator,
                                value: and._data.value,
                                type: and._data.type,
                            });
                    }
                    result.push(orClauseResult);
                }
            }

            this.clauseCount = result.reduce((acc, cur) => acc + cur.length, 0);

            let tree = {};
            let restAndCopy = JSON.parse(JSON.stringify(result));
            let newAndFirst = restAndCopy[0];
            restAndCopy.shift();
            tree = this.processOr(newAndFirst, restAndCopy);
            this.advancedQueryCriteria[this.queryCategory] = tree;
        },
        processOr(node, rest) {
            let newNode = {};

            if (!rest || rest.length > 0) {
                newNode.operator = "OR";

                let nodeSplit = this.splitHeadAndTail(node);
                newNode.left = this.processAnd(nodeSplit.head, nodeSplit.tail);

                let restSplit = this.splitHeadAndTail(rest);
                newNode.right = this.processOr(restSplit.head, restSplit.tail);
            } else if (node) {
                let andSplit = this.splitHeadAndTail(node);
                newNode = this.processAnd(andSplit.head, andSplit.tail);
            }
            return newNode;
        },
        splitHeadAndTail(arr) {
            let arrCopy = JSON.parse(JSON.stringify(arr));
            let first = arrCopy[0];
            arrCopy.shift();
            return {
                head: first,
                tail: arrCopy,
            };
        },
        processAnd(node, rest) {
            
            let newNode = {};

            if (!rest || rest.length > 0) {
                newNode.operator = "AND";
                newNode.left = this.makeNode(node);

                let restSplit = this.splitHeadAndTail(rest);
                newNode.right = this.processAnd(restSplit.head, restSplit.tail);
            } else {
                newNode = this.makeNode(node);
            }

            return newNode;
        },
        makeNode(node) {
            return {
                operator: "==",
                field: `${node.type}.${node.field}`,
                value: node.value,
            };
        },
    },
};
</script>

<style scoped>
.subQueryHeader {
    background: #f2f7f8 !important;
    margin-bottom: 20px;
}

.subQueryItemContainer {
    width: 80%;
    align-self: center;
}

.subQueryItem {
    background: white !important;
    margin-left: 15px;
}

.add-or-clause-button {
    cursor: pointer;
    padding-left: 15px;
}

.subQueryItemContainer .mdi-plus-circle {
    color: #009efb;
    font-size: 20px;
}

.subQueryItemContainer .mdi-close-circle {
    color: palevioletred;
    font-size: 20px;
    cursor: pointer;
}

.card {
    margin: 0;
    padding: 0;
}

.card-header {
    padding: 0rem;
}

.card-body {
    padding-top: 20px;
    padding-bottom: 20px;
}
</style>
